/**
 * What a player is allowed to do.
 *
 * Three ranks rather than a list of permissions, because a list of permissions is
 * a thing to get wrong quietly and three ranks is a thing to reason about. The
 * server decides which one an account holds and the client is told; the client
 * uses it to decide what to draw and never to decide what is allowed.
 */

export const Role = {
  Player: 'player',
  /** Can see and act on other players: kicking, muting, reading reports. */
  Moderator: 'moderator',
  /** Everything, including changing the world and what is in it. */
  SuperAdmin: 'superadmin',
} as const;

export type RoleValue = (typeof Role)[keyof typeof Role];

const ORDER: Record<RoleValue, number> = {
  [Role.Player]: 0,
  [Role.Moderator]: 1,
  [Role.SuperAdmin]: 2,
};

/** Whether a role is at least another one. */
export function atLeast(held: RoleValue, needed: RoleValue): boolean {
  return ORDER[held] >= ORDER[needed];
}

/** Turns whatever is stored into a role, defaulting to the harmless one. */
export function toRole(value: string | null | undefined): RoleValue {
  switch (value) {
    case Role.SuperAdmin:
    case 'administrator':
      return Role.SuperAdmin;
    case Role.Moderator:
      return Role.Moderator;
    default:
      return Role.Player;
  }
}
